<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header mb-3">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('ven-cliente-geral-ppgto') }}
                        </h1>
                    </div>
                    <div class="header-buttons">
                        <button class="delete-btn" type="button" @click="fecharModal()">
                            {{ $t('cancelar') }}
                        </button>
                        <button
                            v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-4">
                            <v-input
                                :id="generateId(1)"
                                ref="idErpInput"
                                v-model="prazoPagamento.idprazopagtoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                tooltipLabel="cod-ref"
                                required
                                :invalid="!prazoPagamento.idprazopagtoerp"
                            />
                        </div>
                        <div class="column is-4">
                            <v-input
                                :id="generateId(2)"
                                ref="nomeInput"
                                v-model="prazoPagamento.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="descricao"
                                msg="msg-campo-obrigatorio"
                                :invalid="!prazoPagamento.descricao"
                                uppercase
                                required
                                tooltipLabel="info-situacao-generica"
                            />
                        </div>

                        <div class="column is-4">
                            <vss-select
                                :id="generateId(3)"
                                ref="situacaoSelect"
                                :searchable="false"
                                :options="situacoes"
                                v-model="situacao"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="prazoPagamento.id == null"
                                title="situacao"
                                required
                                tooltipLabel="info-situacao-generica"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PrazoPagtoService from '@/services/vendas/prazopagto/PrazoPagtoService';
import AssPrazoPagamentoClienteService from '@/services/vendas/cliente/abas/AssPrazoPagamentoClienteService';
import PrazoPagamentoValidation from '@/services/validations/vendas/prazopagto/PrazoPagamentoValidation';
import Message from '@/models/Message';

/* @70957 */
export default {

    props: {
        idCliente: 0,
        permissaoVincular: false,
    },
    data() {
        return {
            service: new PrazoPagtoService(this.$http, this.$router),
            serviceAss: new AssPrazoPagamentoClienteService(this.$http, this.$routers),
            validation: new PrazoPagamentoValidation(this.msgs),
            isLoading: false,
            msgs: [],
            isSaving: false,
            prazoPagamento: {
                id: null,
                descricao: null,
                situacao: null,
            },
            isUpdate: false,
            situacoes: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacao: { label: 'ativo', id: 1 },
            isVenda: this.$route.meta.contexto == 'vendas',
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('vendas', 'vendas', 'ven-prazo-pagamento');

        if (!this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'prazo-pagamento' },
            });
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .find(id)
                .then((value) => {
                    this.prazoPagamento = value.content;
                    this.situacao = this.situacoes[this.prazoPagamento.situacao];
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        save() {
            this.isLoading = true;

            if (this.validation.validate(this.prazoPagamento, this.$refs)) {
                let prazoTemp = Object.assign({}, this.prazoPagamento);
                prazoTemp = this.mapTosave(prazoTemp);
                prazoTemp.situacao = this.situacao.id;

                this.isSaving = true;
                this.service
                    .save(prazoTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = 'msg-save-prazo-pagamento';
                            if (this.prazoPagamento.idprazopagto != null) {
                                msg = 'msg-edit-prazo-pagamento';
                            }
                            this.msgs.push(new Message('success', msg, true));
                            if (this.permissaoVincular) {
                                this.promptConfirmaVinculo(value.content);
                            } else {
                                this.$emit('fecharModal', null);
                            }
                        } else {
                            if (this.$te(value.message)) {
                                if (value.message == 'msg-codigo-duplicado-n') {
                                    this.msgs.push(
                                        new Message(
                                            'alert',
                                            this.$t(value.message, { n: prazoTemp.idprazopagtoerp }),
                                            true,
                                            false
                                        )
                                    );
                                } else {
                                    this.msgs.push(new Message('alert', value.message, true));
                                }
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        let message = e.body.message;
                        if (message) {
                            if (message == 'msg-codigo-duplicado-n') {
                                this.msgs.push(
                                    new Message(
                                        'alert',
                                        this.$t(message, { n: prazoTemp.idprazopagtoerp }),
                                        true,
                                        false
                                    )
                                );
                            } else if (this.$te(message)) {
                                this.msgs.push(new Message('alert', message, true));
                            }

                            return;
                        }

                        this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },
        promptConfirmaVinculo(prazo) {
            this.$root.confirm({
                message: this.$t('deseja-realizar-vinculo'),
                onConfirm: (_) => {
                    this.realizarVinculo(prazo);
                },
                onCancel: (_) => {
                    this.fecharModal();
                },
            });
        },
        realizarVinculo(prazo) {
            let assTemp = [
                {
                    idprazopagto: prazo.idprazopagto,
                    idcliente: this.idCliente,
                },
            ];

            this.savePP(assTemp)
                .then((value) => {
                    if (value.content === null) {
                        this.msgs.push(new Message('error', `${value.message}`, true));
                    } else {
                        this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
                        this.$emit('fecharModal', prazo);
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message('alert', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        savePP() {
            if (this.isVenda) return this.serviceAss.saveVendas(this.prazoPagamentoSelecionados);
            else return this.serviceAss.saveAgro(this.prazoPagamentoSelecionados);
        },
        fecharModal() {
            this.$emit('fecharModal', null);
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
